import React from "react";
import "../css/ContentPage.css";
import instant_loan from "../images/instanloan.png";
import { Link } from "react-router-dom";
import ChatButton from "../components/ChatButton";
import { email } from "../constants";


const InstantLoan = () => {
  return (
    <>
      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
          <div className="service_page_banner_wrapper_overlay">
            <h2>Loan for Low CIBIL</h2>
          </div>

          <div className="text_content_wrapper">
            <div className="text_content">
              {/* <div className="content_banner">
                <img src={instant_loan} alt="" />
              </div> */}
              <div>
                <h2 className="page_title mt30 mb20">Loan for Low CIBIL</h2>

                <p>Being a highly reliable NBFC in India, CreduMoney offers ‘Loan for Low CIBIL’ to those salaried individuals with a not-so-ideal credit history or a low credit score. We truly understand that financial requirements may arise for anyone, regardless of their credit score. Secondly, we also understand that a low/poor CIBIL score does not always reflect your present repaying capacity. Therefore, we don’t evaluate your eligibility for obtaining a personal loan based on your CIBIL score. </p>

                <p>How do we evaluate your eligibility, then? We take notice of your recent credit history/recent repayment habits. If your recent track record is satisfactory, you can easily avail yourself of a personal loan from us. For instance, you defaulted on a loan a few years ago, resulting in a slump in your CIBIL score. However, you took two or three loans following that and have successfully repaid the amount on time; that’s enough for us to consider your application and help you get instant funds right into your bank account. </p>

                <p>Unfortunately, Banks don’t offer loans for Low CIBIL due to the credit risk, and therefore, they reject such applications upfront, closing their doors for any financial help. But a huge thanks to NBFCs and digital lending platforms, such as CreduMoney, that they extend their helping hand when you need funds the most. With CreduMoney, you can secure a personal loan of up to 1 LAKH in just 10 minutes by applying through PAN, Aadhar and Bank Statement. The best part is that our personal loans are collateral-free. </p>

              </div>
              <div className="button_container flex justify-center">
                <Link to="/apply-now">Apply Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default InstantLoan;
